import { HttpClient } from '@angular/common/http';
import { download } from './download';
import { Saver } from './saver.provider';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./saver.provider";
export class DownloadService {
    constructor(http, save) {
        this.http = http;
        this.save = save;
    }
    download(url, filename) {
        return this.http.get(url, {
            reportProgress: true,
            observe: 'events',
            responseType: 'blob'
        }).pipe(download(blob => this.save(blob, filename)));
    }
    blob(url, filename) {
        return this.http.get(url, {
            responseType: 'blob'
        });
    }
}
DownloadService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DownloadService_Factory() { return new DownloadService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.SAVER)); }, token: DownloadService, providedIn: "root" });
